export default {"src":"/_next/static/media/blog.6eb36276.svg","height":718,"width":1010,"blurWidth":0,"blurHeight":0};